import React, { ReactElement } from "react"
import { Icon, Button } from "@/components"
import { Menu } from "@mantine/core"
import { useStyles } from "@/components/DropdownButton/DropdownButton.styles"

export const DropdownButton = (props: {
    text: string
    leftIcon: ReactElement
    variant: string
    children: React.ReactNode
}) => {
    const [opened, setOpened] = React.useState(false)
    const { classes } = useStyles()
    return (
        <Menu opened={opened} offset={8} onChange={setOpened} position="bottom-start" width="target">
            <Menu.Target>
                <Button
                    className={classes.button}
                    rightIcon={<Icon icon={`${opened ? "angle-up" : "angle-down"}`} />}
                    leftIcon={props.leftIcon}
                    onClick={() => setOpened((o) => !o)}
                    variant={props.variant}
                >
                    {props.text}
                </Button>
            </Menu.Target>
            <Menu.Dropdown>{props.children}</Menu.Dropdown>
        </Menu>
    )
}
